import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useAuth } from '../../contexts/AuthContext';
import Button from '../../components/ui/Button';
import Input from '../../components/ui/Input';
import { ArrowLeft, LogIn } from '../../lib/lucide-proxy';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || '/dashboard';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) return;
    setLoading(true);
    const { error } = await signIn(email, password);
    if (!error) {
      // Navegação será tratada pelo AuthContext/useEffect, mas forçamos aqui por segurança
      navigate(from, { replace: true });
    }
    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>Entrar - Cerveja Delivery</title>
      </Helmet>
      <div className="min-h-screen bg-cream-300 flex flex-col justify-center py-12 sm:px-6 lg:px-8 relative overflow-hidden">
        {/* Decorative Background Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-primary-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse-custom"></div>
          <div className="absolute bottom-[-10%] left-[-5%] w-96 h-96 bg-copper-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse-custom" style={{ animationDelay: '1s' }}></div>
        </div>

        <div className="sm:mx-auto sm:w-full sm:max-w-md relative z-10">
          <Link to="/" className="inline-flex items-center mb-8 text-dark-500 hover:text-primary-500 transition-colors font-medium group">
            <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-2 shadow-sm group-hover:shadow-md transition-all">
              <ArrowLeft className="w-4 h-4" />
            </div>
            Voltar para Home
          </Link>
          <div className="text-center mb-8">
            <div className="mx-auto w-16 h-16 bg-primary-500 rounded-2xl flex items-center justify-center mb-4 shadow-soft transform rotate-3">
              <span className="text-white font-bold text-2xl">C</span>
            </div>
            <h2 className="font-display font-bold text-3xl text-dark-900">
              Bem-vindo de volta
            </h2>
            <p className="mt-2 text-dark-600">
              Acesse sua conta para continuar
            </p>
          </div>
        </div>

        <div className="mt-2 sm:mx-auto sm:w-full sm:max-w-md relative z-10">
          <div className="bg-white py-10 px-4 shadow-large rounded-2xl sm:px-10 border border-gray-100">
            <form className="space-y-6" onSubmit={handleSubmit}>
              <Input 
                label="Email" 
                type="email" 
                required 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                placeholder="seu@email.com"
                autoComplete="email"
              />
              
              <div>
                <Input 
                  label="Senha" 
                  type="password" 
                  required 
                  value={password} 
                  onChange={(e) => setPassword(e.target.value)} 
                  placeholder="••••••••"
                  autoComplete="current-password"
                />
                <div className="flex justify-end mt-2">
                  <Link 
                    to="/forgot-password" 
                    className="text-sm font-medium text-primary-600 hover:text-primary-500 transition-colors"
                  >
                    Esqueceu a senha?
                  </Link>
                </div>
              </div>

              <Button 
                type="submit" 
                variant="primary" 
                className="w-full flex justify-center items-center shadow-lg hover:shadow-xl" 
                loading={loading}
                size="lg"
              >
                <LogIn className="w-5 h-5 mr-2" />
                Entrar
              </Button>
            </form>

            <div className="mt-8 pt-6 border-t border-gray-100 text-center">
              <p className="text-dark-500 text-sm">
                Não tem uma conta?{' '}
                <Link to="/register" className="font-semibold text-primary-600 hover:text-primary-500 transition-colors">
                  Criar conta agora
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;